// Banner generation — domain-only flow.
// Backend scrapes the domain, runs an LLM art director, renders the image,
// overlays the LLM-written tagline, and returns { image_url, direction_tag, tagline }.
import api from '../../../services/api';

export const generateBanner = async ({ companyDomain, divergeFrom }) => {
  try {
    const submitData = new FormData();
    submitData.append('company_domain', (companyDomain || '').trim());
    if (divergeFrom) {
      submitData.append('diverge_from', divergeFrom);
    }

    const response = await api.post(
      '/api/generate-banner',
      submitData,
      {
        headers: { 'Content-Type': 'multipart/form-data' },
        // Backend can take up to ~8-10 min during OpenAI outages (5 retries w/
        // exponential backoff + gpt-image-1 fallback). Give it the full window.
        timeout: 600000,
      }
    );

    return {
      imageUrl: response.data.image_url,
      directionTag: response.data.direction_tag,
      tagline: response.data.tagline,
      elementsCaptured: response.data.elements_captured || null,
    };
  } catch (error) {
    console.error('Error generating banner:', error);

    if (error.response?.status === 401) throw new Error('AUTH_REQUIRED');
    if (error.response?.status === 402) throw new Error('INSUFFICIENT_CREDITS');
    if (error.response?.status === 422) {
      // Scrape-failure: backend sends a specific, actionable message.
      throw new Error(error.response.data?.detail || "We couldn't read that domain. Check the URL and try again.");
    }
    if (error.response?.status === 503 || error.code === 'ECONNABORTED') {
      throw new Error('We are experiencing high demand, try again later.');
    }
    throw new Error(
      error.response?.data?.detail || 'We are experiencing high demand, try again later.'
    );
  }
};
